// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1gUjF","footer":"styles_footer__3BFYC","passCodeTooltip":"styles_passCodeTooltip__1mop0"};